
import { companyListExpiringReducer } from "../reducer/CompanyListExpiringReducer";

export const reducer = companyListExpiringReducer;